import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: undefined,
  },
  staticLabel: Boolean,
  clearable: Boolean,
  disabled: Boolean,
},
  emits: ['update:model-value'],
  setup(__props) {

const props = __props





// Show a border if no value or fully white
const border = computed(() => (!props.modelValue || props.modelValue.toLowerCase() === '#ffffff') ? 'border border-grey-dark' : '')

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_color = _resolveComponent("q-color")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createElementBlock("label", {
    tabindex: "0",
    class: _normalizeClass(["flex items-center cursor-pointer h-10 group max-w-max", { 'cursor-not-allowed text-grey-dark': __props.disabled }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["rounded-full h-[30px] w-[30px] mr-2", { 'border': _unref(border) }]),
      style: _normalizeStyle({ background: __props.modelValue })
    }, null, 6),
    _createElementVNode("span", null, _toDisplayString((!__props.staticLabel ? __props.modelValue?.toLowerCase() : false) || __props.label || 'not selected'), 1),
    (__props.clearable && __props.modelValue && !__props.disabled)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: "mdi-close",
          color: "grey-darker",
          class: "cursor-pointer ml-2 opacity-0 group-hover:opacity-100",
          size: "18px",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:model-value', null)), ["stop"]))
        }))
      : _createCommentVNode("", true),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_q_menu, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_q_color, {
              "model-value": __props.modelValue,
              "no-header-tabs": "",
              "no-footer": "",
              style: {"width":"290px"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event)))
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})